import { useEffect, useState, startTransition } from "react";
import { Grid } from "@mui/material";
import styles from "./styles.module.scss";
import { Heading } from "../modules/molecules/heading/heading";
import { useTableContext } from "../context/tableContext";
import _dashboardLinks from "../layout/sidebar.links";
import { HeaderV1 } from "gf-ui-components-mui-lib";
import { useFileUploadContext } from "../context/fileUploadContext";
import { FilterKeywords } from "../modules/molecules/filterKeywords/filterKeywords";
import { RenderFilters } from "../modules/organisms/filterWindow/renderFilters";
import { RoleFilter } from "../modules/organisms/filterWindow/roleFilter";
import { UpdateStatus } from "../modules/molecules/updateStatusModal/updateStatus";
import { FilterHeader } from "../modules/molecules/filterRender/FilterHeader";
import { ClientWindow } from "../modules/organisms/generateClient/clientWindow";
import { GenerateHeader } from "../modules/molecules/generateScreen/header";
import { FileUploadStatus } from "../modules/atoms/UploadModal/FileStatus";
import { downloadExportData } from "../services/downloadTemplate";
import { exportAll } from "../enums/endpoints";
import exportCSV from "@/assets/svg/Export all.svg";
import exportCSVWhite from "@/assets/img/export-csv-contained.svg";
import SuccessIcon from "@/assets/svg/info-circle.svg";
import FailedIcon from "@/assets/svg/failed.svg";
import ErrorIcon from "@/assets/svg/error.svg";
import UploadCloud from "@/assets/svg/upload-cloud.svg";
import UploadCloudSecond from "@/assets/svg/upload-cloud-02.svg";
import DeleteIconImage from "@/assets/img/delete.svg";
import { headerButtonLinks, toolbarButtonLinks } from "../layout/button.links";
import DeviceManagerLogo from "@/assets/svg/DEVICE MANAGER.svg";
import MultipleSelectCheckmarks from "../modules/molecules/CustomFilter";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { modGetAllowedUrls } from "../utils";
import useUserHook from "../pages/User/userHook";
import { ReactComponent as DashBoardIcon } from "../assets/img/dashboard-icon.svg";
import { ReactComponent as InventoryIcon } from "../assets/img/inventory-icon.svg";
import { ReactComponent as Inventory2Icon } from "../assets/img/inventory2.svg";
import SidebarWithProductDropdown, {
  SidebarItem,
} from "../modules/molecules/sidebar";
import { useAuth } from "src/hooks/useLogin";

// XSM-1536: SSO Login
function MainLayout() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [select, setSelect] = useState("inventory2");
  const location = useLocation();
  const navigate = useNavigate();
  const {
    rowsPerPage,
    selectedRows,
    tableData,
    chargerValue,
    showGenerate,
    applyFilter,
    setPaginationBottom,
    checked,
    connectors,
    filterModel,
    filterStatus,
    filterTenant,
    connectorType,
    filterOcpp,
    qrFlag,
    showNext,
    selectedWareHouseRows,
    setChargerValue,
    statusList,
    setShowNext,
    nextButton,
    generateButton,
    generateFlag,
    setGenerateFlag,
    arrowBackButton,
    closeButton,
    resetFilters,
    setOpenFilter,
    openFilter,
    updatedWareHouseData,
    setUpdateStatusWindow,
    updateStatusWindow,
    setApplyFilter,
    selectedRowsWithPage,
    selectedClients,
    handleChangeClient,
    clientinfo,
    setUserValue,
    userValue,
    applyRole,
    applyEmail,
    setApplyRole,
    setApplyEmail,
    uniqueEmails,
    uniqueRoles,
  } = useTableContext();
  const {
    uploadView,
    handleFileUpload,
    setUploadView,
    successWindow,
    failedWindow,
    errorWindow,
    setSuccessWindow,
    setFailedWindow,
    uploadProgress,
  } = useFileUploadContext();
  const { handleLogout } = useAuth();
  const { createNewUser, permissionAccess } = useUserHook();
  const [filteredLinks, setFilteredLinks] = useState<SidebarItem[]>([]);

  useEffect(() => {
    const userScope = localStorage.getItem("dm_userscope") as string;
    const permissions = userScope ? JSON.parse(userScope) : [];
    if (permissions) {
      const mod = modGetAllowedUrls(permissions);
      const filterLinks = (links: any) => {
        return links.reduce((filtered: any, link: any) => {
          if (link.id && mod.has(link.id)) {
            // Include the link if it matches the allowedUrls
            filtered.push({ ...link });
          }
          return filtered;
        }, []);
      };

      const defaultLinks = [
        {
          id: "dashboard",
          icon: (
            <DashBoardIcon
              stroke={select === "dashboard" ? "white" : "black"}
            />
          ),
          label: "Dashboard",
          url: "/dashboard",
        },
        {
          id: "inventory1",
          icon: (
            <InventoryIcon
              stroke={select === "inventory1" ? "white" : "black"}
            />
          ),
          label: "Inventory-1",
          url: "/inventory1",
        },
        {
          id: "inventory2",
          icon: (
            <Inventory2Icon
              stroke={select === "inventory2" ? "white" : "black"}
            />
          ),
          label: "Inventory-2",
          url: "/inventory2",
        },
      ];

      const updatedLinks = [
        ...defaultLinks,
        ...filterLinks(_dashboardLinks(select)),
      ];
      setFilteredLinks(updatedLinks);
    }
  }, [select]);

  useEffect(() => {
    if (!filteredLinks.length) {
      return;
    }
    const matchingLink = filteredLinks.find(
      (link) =>
        link.url &&
        (location.pathname === link.url ||
          location.pathname.startsWith(`${link.url}/`))
    );
    if (matchingLink && matchingLink.id !== select) {
      // Use startTransition to sync state update with route changes
      startTransition(() => {
        setSelect(matchingLink.id);
      });
    }
  }, [filteredLinks, location.pathname, select]);

  const handleSidebarSelection = (item: SidebarItem) => {
    if (item.url && item.url !== location.pathname) {
      const url = item.url;
      // Update selection state and navigate together in a transition to prevent glitches
      startTransition(() => {
        if (item.id !== select) {
          setSelect(item.id);
        }
        navigate(url as string);
      });
    } else if (item.id !== select) {
      setSelect(item.id);
    }
  };

  const [filterPresent, setFilterPresent] = useState(0);
  useEffect(() => {
    if (
      applyFilter &&
      (checked?.length > 0 ||
        connectorType?.length > 0 ||
        filterStatus?.length > 0 ||
        filterModel !== "" ||
        filterTenant !== "" ||
        connectors !== "" ||
        qrFlag !== "" ||
        filterOcpp !== "")
    ) {
      setPaginationBottom(true);
    }

    if (applyFilter && tableData?.length < rowsPerPage) {
      setPaginationBottom(false);
    }

    if (!applyFilter) {
      setPaginationBottom(false);
    }

    if (checked?.length > 0) {
      setFilterPresent((prev: any) => prev + 1);
    }

    if (checked?.length === 2) {
      setFilterPresent((prev: any) => prev + 1);
    }

    if (filterStatus?.length > 0) {
      setFilterPresent((prev: any) => prev + 1);
    }

    if (filterStatus?.length === 2) {
      setFilterPresent((prev: any) => prev + 1);
    }

    if (connectorType?.length > 0) {
      setFilterPresent((prev: any) => prev + 1);
    }

    if (connectorType?.length === 2) {
      setFilterPresent((prev: any) => prev + 1);
    }

    if (connectors !== "") {
      setFilterPresent((prev: any) => prev + 1);
    }

    if (filterModel !== "") {
      setFilterPresent((prev: any) => prev + 1);
    }

    if (filterOcpp !== "") {
      setFilterPresent((prev: any) => prev + 1);
    }

    if (filterTenant !== "") {
      setFilterPresent((prev: any) => prev + 1);
    }

    if (qrFlag !== "") {
      setFilterPresent((prev: any) => prev + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    applyFilter,
    checked,
    connectors,
    filterModel,
    filterStatus,
    filterTenant,
    connectorType,
    filterOcpp,
    qrFlag,
  ]);

  const isAuthenticated = () => {
    const isLoggedIn = localStorage.getItem("dm_isLoggedIn");
    return isLoggedIn === "true";
  };

  return (
    <Grid container className={`${styles.App}`}>
      {isAuthenticated() ? (
        <>
          <Grid className={styles.sidebarContainer}>
            <SidebarWithProductDropdown
              items={filteredLinks}
              selectedItem={select}
              onSelect={handleSidebarSelection}
              logo={
                <img
                  src={DeviceManagerLogo}
                  alt="Device Manager"
                  className={styles.sidebarLogo}
                />
              }
              onLogout={handleLogout}
            />
          </Grid>
          <Grid className={`${styles.tableContainer}`}>
            <HeaderV1
              xsmadmin={false}
              sx={{
                background: "transparent",
                boxShadow: "none",
                position: "static",
                paddingLeft: "0px",
                padding: 0,
                "@media (max-width: 1440px)": {
                  "& .MuiToolbar-root": {
                    minHeight: "20px",
                    height: 30,
                    marginTop: "5px",
                    fontSize: "16px !important",
                  },
                },
              }}
              tenantSelect={select === "inventory2" ? true : false}
              tenantDropdown={
                <MultipleSelectCheckmarks
                  {...{ selectedClients, handleChangeClient, clientinfo }}
                />
              }
              logo={
                <Heading
                  title={
                    select === "user-management"
                      ? "User Management"
                      : "Device Manager"
                  }
                />
              }
              setChargerValue={setChargerValue}
              statusList={statusList}
              showNext={showNext}
              setShowNext={setShowNext}
              showGenerate={showGenerate}
              nextButton={nextButton}
              generateButton={generateButton}
              generateFlag={generateFlag}
              setGenerateFlag={setGenerateFlag}
              arrowBackButton={arrowBackButton}
              closeButton={closeButton}
              chargerValue={chargerValue}
              checked={checked}
              connectors={connectors}
              connectorType={connectorType}
              qrFlag={qrFlag}
              filterStatus={filterStatus}
              filterTenant={filterTenant}
              filterOcpp={filterOcpp}
              filterModel={filterModel}
              tableData={tableData}
              resetFilters={resetFilters}
              setOpenFilter={setOpenFilter}
              openFilter={openFilter}
              applyFilter={applyFilter}
              // uploadView={uploadView}
              handleFileUpload={handleFileUpload}
              // setUploadView={setUploadView}
              successWindow={successWindow}
              failedWindow={failedWindow}
              errorWindow={errorWindow}
              setSuccessWindow={setSuccessWindow}
              setFailedWindow={setFailedWindow}
              FilterKeywords={<FilterKeywords />}
              RenderFilters={(applyRole && <RoleFilter />) || <RenderFilters />}
              UpdateStatus={<UpdateStatus />}
              FilterHeader={<FilterHeader />}
              ClientWindow={<ClientWindow />}
              setUpdateStatusWindow={setUpdateStatusWindow}
              updateStatusWindow={updateStatusWindow}
              permissionAccess={permissionAccess}
              GenerateHeader={
                <GenerateHeader
                  showNext={showNext}
                  showGenerate={showGenerate}
                  generateButton={generateButton}
                  arrowBackButton={arrowBackButton}
                  closeButton={closeButton}
                  nextButton={nextButton}
                  selectedRowsLength={selectedRows?.length}
                />
              }
              FileUploadStatusError={
                <FileUploadStatus
                  imageIcon={ErrorIcon}
                  status={"Failed to Upload File"}
                  displayMessage={errorWindow?.message}
                />
              }
              FileUploadStatusSuccess={
                <FileUploadStatus
                  imageIcon={SuccessIcon}
                  status={"Success!!"}
                  displayMessage={successWindow?.message}
                />
              }
              FileUploadStatusFailed={
                <FileUploadStatus
                  imageIcon={FailedIcon}
                  status={"Something went wrong!"}
                  displayMessage={failedWindow?.message}
                />
              }
              downloadExportData={downloadExportData}
              exportAll={exportAll}
              exportCSV={exportCSV}
              exportCSVWhite={exportCSVWhite}
              SuccessIcon={SuccessIcon}
              FailedIcon={FailedIcon}
              headerButtonLinks={
                location.pathname === "/user-management"
                  ? []
                  : headerButtonLinks
              }
              toolbarButtonLinks={toolbarButtonLinks}
              uploadProgress={uploadProgress}
              UploadCloud={UploadCloud}
              UploadCloudSecond={UploadCloudSecond}
              DeleteIconImage={DeleteIconImage}
              selectedWareHouseRows={selectedWareHouseRows}
              selectedRows={selectedRows}
              setApplyFilter={setApplyFilter}
              selectedRowsWithPage={selectedRowsWithPage}
              isUser={location.pathname === "/user-management" ? true : false}
              createUser={createNewUser}
              setUserValue={setUserValue}
              userValue={userValue}
              setApplyRole={setApplyRole}
              setApplyEmail={setApplyEmail}
              applyRole={applyRole}
              applyEmail={applyEmail}
              uniqueEmails={uniqueEmails}
              uniqueRoles={uniqueRoles}
            />
            <Outlet />
          </Grid>
        </>
      ) : (
        <Navigate to="/" replace />
      )}
    </Grid>
  );
}

export default MainLayout;
